/* Theme-only presentation adapter. Easify retains validation, uploads and order properties. */
(() => {
  const node = document.getElementById('MPUploadAdapterCopy');
  const root = document.getElementById('MainContent');
  if (!node || !root) return;
  const copy = JSON.parse(node.textContent);
  const labels = new Map([
    ['Lade dein Bild hoch:', copy.title], ['Eigenes Foto hochladen', copy.choose],
    ['KI-Upscaling', copy.upscale],
    ['Bitte achte auf eine ausreichende Qualtität von deinem Foto. Bist du dir unsicher, kann unser Qualitätsprüfer dir helfen.', copy.hint],
    ['Bilder werden nicht von unserem Team manuell überprüft. Bitte achte auf eine ausreichende Druckqualität oder nutze unseren Qualitätsprüfer um diese zu checken.', copy.note],
    ['Something went wrong! Please try again.', copy.failed], ['This is a required option', copy.required]
  ]);
  let scheduled = false;
  function translate() {
    scheduled = false;
    root.querySelectorAll('.tpo_option-help-text, .tpo-dropzone__action, .tpo_option_type_label, .form__label[class*="tpo_"], .tpo_error-message, [class*="tpo_tooltip"]').forEach(element => {
      const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const text = node.nodeValue.trim();
        let replacement = labels.get(text);
        if (text.startsWith('Please upload file having extensions ')) replacement = copy.formats;
        if (text === 'Uploading...') replacement = copy.uploading;
        if (replacement && replacement !== text) node.nodeValue = node.nodeValue.replace(text, replacement);
      }
      if (element.classList.contains('tpo_error-message')) element.setAttribute('role', 'alert');
    });
    root.querySelectorAll('.tpo-delete__file').forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('tabindex', '0');
      element.setAttribute('aria-label', copy.remove);
    });
  }
  root.addEventListener('keydown', event => {
    if (event.target.matches('.tpo-delete__file') && ['Enter', ' '].includes(event.key)) {
      event.preventDefault();
      event.target.querySelector('svg')?.dispatchEvent(new MouseEvent('click', { bubbles: true }));
    }
  });
  translate();
  new MutationObserver(() => {
    if (!scheduled) { scheduled = true; requestAnimationFrame(translate); }
  }).observe(root, { childList: true, subtree: true, characterData: true });
})();
